module.exports = __webpack_public_path__ + "img/empty-bg.c5dd92a4.png";